'use client'

import { Dialog, DialogPanel, TransitionChild } from '@headlessui/react'

import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop'
import { TopNavAccountPanelContent } from '@src/components/TopNavV4/TopNavAccountPanel/TopNavAccountPanelContent'
import { useTopNav } from '@src/components/TopNavV4/TopNavContext'
import { useQuerySelector } from '@src/hooks/useQuerySelector'
import { cn } from '@src/utils/tailwind'

export const TopNavAccountPanel = () => {
  const { isAccountExpanded, setAccountExpanded } = useTopNav()
  const isHeadlessUIReady = !!useQuerySelector('#headlessui-portal-root')

  return (
    <Dialog
      transition
      open={isAccountExpanded && isHeadlessUIReady}
      onClose={() => setAccountExpanded(false)}
      className="relative z-max transition duration-200 ease-out"
    >
      <ModalBackdrop className="hidden backdrop-blur-sm lg:block" />

      <div className="fixed inset-0 flex justify-end overflow-y-auto">
        <TransitionChild>
          <DialogPanel
            className={cn(
              'size-full max-w-full lg:w-[420px]',
              'duration-200 ease-out data-[closed]:translate-x-full'
            )}
          >
            <TopNavAccountPanelContent />
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  )
}
